import { LOGIN_METHOD } from 'src/interfaces/LoginMethod';

export const PASSWORD_MASK = '********';
export const LOGIN_SETTINGS_TITLE_ID = 'login-settings-title';
export const LOGIN_SETTINGS_DESCRIPTION_ID = 'login-settings-description';

export const LOGIN_METHOD_TYPE = {
	NOT_REQUIRED: 'Not Required',
	FORM_LOGIN: 'Form login',
	COOKIES: 'Login with cookies'
} as const;

export type LoginMethodType = (typeof LOGIN_METHOD_TYPE)[keyof typeof LOGIN_METHOD_TYPE];

export const LOGIN_METHOD_TO_TYPE: Record<string, LoginMethodType> = {
	[LOGIN_METHOD.LOGIN_FORM]: LOGIN_METHOD_TYPE.FORM_LOGIN,
	[LOGIN_METHOD.COOKIES]: LOGIN_METHOD_TYPE.COOKIES
};
